<template>
        <div style=" display: flex;justify-content: space-between; flex-direction:row-reverse ">
          <el-dropdown>
              <span class="iconfont icon-setup" style="margin-right: 10px">{{userName}}</span>
               <template #dropdown>

                    <el-dropdown-menu>
                         <el-dropdown-item @click="updatepwd">修改密码</el-dropdown-item>
                         <el-dropdown-item @click="exit">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
               </template>

          </el-dropdown>
<!--            <span>{{userName}}</span>-->
          <div>
               <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item><a :href="path">{{currentPathName}}</a></el-breadcrumb-item>
<!--                    <el-breadcrumb-item>活动列表</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item>活动详情</el-breadcrumb-item>-->
               </el-breadcrumb>
          </div>
    </div>
	<div >
    <el-dialog  width="50%" v-model="dialogVisible">
      <el-form ref="editform" :model="editform" :rules="rules" label-width="80px">
        <el-form-item label="密码" status-icon label-width="160px" style="float:left;">
          <el-input v-model="passWord" style="width: 300px;" :disabled="disabled1" placeholder="请输入新密码"></el-input>
          <!--              <el-input v-model="form.authorityId" type="hidden"/>-->
        </el-form-item>
      </el-form>
      <template #footer>
                      <span class="dialog-footer">
                        <el-button style="margin-top: 20px" @click="cancel">关闭</el-button>
                        <el-button style="margin-top: 20px" type="primary" @click="editSubmit">确定</el-button>
                      </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
    // import store from '@/store/index.js'
    import request from "@/util/request";
    export default {
        name: "LCHearder",
        data(){
            return{
userName:sessionStorage.getItem("userName"),
dialogVisible: false,
editform: {},
passWord: '',
                // currentPathName:this.$store.getters.getCurrentPathName,
                // path:"/"+this.$store.getters.getCurrentPathName,
            }

        },
        computed: {
            currentPathName: function() {
                return this.$store.getters.getCurrentPathName;
            },
            // currentPathName: function() {
            //     return this.$store.getters.getCurrentPathName;
            // },
        },
        methods: {
            exit(){
                sessionStorage.removeItem("userName");
                this.$router.push({path:'login', query:{}});
            },
            updatepwd() {
            this.dialogVisible = true;
            this.passWord = ''
          },
          cancel() {
            this.dialogVisible = false;
          },
          editSubmit() {
            // eslint-disable-next-line no-undef
              if (this.passWord == null || this.passWord == " " || this.passWord == "" || this.passWord == "  "|| this.passWord == "   ") {
                this.$message({
                  type: 'error',
                  message: '密码不能为空!'
                });
              } else {
                let map = {
                  userName: sessionStorage.getItem("userName"),
                  passWord: this.passWord
                }
                request.post('/order/updatePWD', map).then(res => {
                  console.log(res)
                  if (res.code === '0') {
                    this.$message({
                      type: 'success',
                      message: '修改密码成功!'
                    });
                  }
                })
                this.dialogVisible = false
              }
          },
        }
    }
</script>

<style scoped>

</style>